import React from 'react';
import { Star } from 'lucide-react';
import { Button } from './ui/Button';
export function TestimonialsSection() {
  const testimonials = [{
    text: 'Nunca pensé verlo disfrutar tanto al aprender a leer. Antes era una batalla campal, ahora él mismo trae sus hojas de trabajo.',
    author: 'Carolina M.',
    role: 'Mamá de Tomás (6 años)'
  }, {
    text: 'En dos semanas ya reconocía sílabas que le costaban meses en el colegio. Estamos felices y él se siente un superhéroe.',
    author: 'Valeria S.',
    role: 'Mamá de Sofi (5 años)'
  }, {
    text: 'Está más confiado y se anima a formar sus primeras palabras sin miedo a equivocarse. El cambio de actitud es lo que más valoro.',
    author: 'Andrea P.',
    role: 'Mamá de Lucas (7 años)'
  }, {
    text: "Pasamos de peleas y llantos a que él me pida hacer 'los juegos de las letras'. Increíble.",
    author: 'Mariana G.',
    role: 'Mamá de Benja (6 años)'
  }];
  return <section className="py-20 px-4 bg-[#F5F1EA]" data-id="element-151">
      <div className="max-w-4xl mx-auto" data-id="element-152">
        <div className="text-center mb-16" data-id="element-153">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D3648]" data-id="element-154">
            Lo que dicen otras mamás
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-155">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-sm border border-[#5C6B60]/5 flex flex-col h-full" data-id="element-156">
              <div className="flex text-[#C2644C] mb-4" data-id="element-157">
                {[...Array(5)].map((_, idx) => <Star key={idx} className="w-5 h-5 fill-current" data-id="element-158" />)}
              </div>
              <p className="text-[#4A5568] text-lg italic mb-6 flex-grow" data-id="element-159">
                "{t.text}"
              </p>
              <div data-id="element-160">
                <p className="font-bold text-[#2D3648]" data-id="element-161">{t.author}</p>
                <p className="text-sm text-[#5C6B60]" data-id="element-162">{t.role}</p>
              </div>
            </div>)}
        </div>

        {/* Social Proof Image */}
        <div className="mb-16 rounded-2xl overflow-hidden shadow-lg" data-id="element-163"></div>

        <div className="text-center" data-id="element-164">
          <a href="https://www.gaiadigitalpro.com/checkouts/cn/hWN97cYIrZq0N6nxejFJOld3/es-ar?_r=AQABO5WkZAviKo3oQFFbDGNAwsqGY8jRmCI-2Na28krQ6Q0&preview_theme_id=163563503651" target="_blank" rel="noopener noreferrer" data-id="element-165">
            <Button variant="primary" size="lg" className="w-full md:w-auto px-12 rounded-full" data-id="element-166">
              QUIERO VER ESTOS RESULTADOS
            </Button>
          </a>
        </div>
      </div>
    </section>;
}